<h2 mat-dialog-title>{{editMode ? 'Editar Track' :'Crear Track'}}</h2>
<mat-dialog-content>
  <form #form class="example-form">
    <!--canal de inicio-->
    <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Canal para las propuestas</mat-label>
        <input type="text" matInput [formControl]="channel"  [errorStateMatcher]="matcher" maxlength="255" placeholder="Ingrese el canal para las propuestas..." required>
        <mat-hint align="start"><strong></strong></mat-hint>
        <mat-hint align="end">{{channel.value.length}} / 255</mat-hint>
        <mat-error *ngIf="channel.hasError('required')">Canal <strong>requerido</strong></mat-error>
      </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onSubmit()">{{editMode ? 'Guardar' :'Crear'}}</button>
  <button mat-button color="primary" (click)="onClose()">Cancelar</button>
</mat-dialog-actions>
